module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "loginbg"
    }
  }, [_vm._v("  ·\n  "), _c('div', {
    attrs: {
      "id": "ding"
    }
  }, [_c('div', {
    staticClass: "title",
    attrs: {
      "id": "wenzi"
    }
  }, [_vm._v("\n      自提系统\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "title",
    attrs: {
      "id": "zhanghao"
    }
  }, [_vm._v("\n      账号\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "title",
    attrs: {
      "id": "tuichu"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("\n      【退出】\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "title",
    attrs: {
      "id": "yuyue"
    },
    on: {
      "click": _vm.tiaozhuanyuyue
    }
  }, [_vm._v("\n      预约\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "title",
    attrs: {
      "id": "basic"
    },
    on: {
      "click": _vm.shouye
    }
  }, [_vm._v("\n      首页\n    ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "background-color": "white",
      "top": "71px",
      "width": "80%",
      "left": "140px",
      "height": "60px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "position": "absolute",
      "left": "20px",
      "top": "16px"
    },
    attrs: {
      "id": "xiugai ",
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.handleEdit()
      }
    }
  }, [_vm._v("修改")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "position": "absolute",
      "left": "80px",
      "top": "16px"
    },
    attrs: {
      "id": "quxiao",
      "type": "danger",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.handleDelete()
      }
    }
  }, [_vm._v("删除")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "position": "absolute",
      "left": "150px",
      "top": "16px"
    },
    attrs: {
      "id": "daochu",
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.handleadd()
      }
    }
  }, [_vm._v("录入")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "position": "absolute",
      "left": "300px",
      "width": "220px",
      "top": "11px"
    },
    attrs: {
      "placeholder": "商品名称",
      "clearable": ""
    },
    model: {
      value: (_vm.gaojichaxuntemp),
      callback: function($$v) {
        _vm.gaojichaxuntemp = $$v
      },
      expression: "gaojichaxuntemp"
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "position": "absolute",
      "left": "530px",
      "top": "17px",
      "border-radius": "4px"
    },
    attrs: {
      "type": "primary",
      "size": "mini",
      "icon": "el-icon-search"
    },
    on: {
      "click": function($event) {
        return _vm.gaojichaxun()
      }
    }
  }, [_vm._v("搜索")])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "80%",
      "left": "140px",
      "height": "580px",
      "top": "74px"
    },
    attrs: {
      "data": _vm.pageData.rows,
      "size": "mini"
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), (false) ? _c('el-table-column', {
    attrs: {
      "prop": "productId",
      "label": "productId",
      "width": "40"
    }
  }) : _vm._e(), _vm._v(" "), (false) ? _c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "id",
      "width": "40"
    }
  }) : _vm._e(), _vm._v(" "), (false) ? _c('el-table-column', {
    attrs: {
      "prop": "numberId",
      "label": "numberId",
      "width": "40"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "商品名称",
      "width": "250",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "spec",
      "label": "商品规格",
      "width": "320",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "number",
      "label": "商品数量",
      "width": "220",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "url",
      "label": "商品图片",
      "width": "250",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-popover', {
          attrs: {
            "placement": "right",
            "title": "",
            "trigger": "hover"
          }
        }, [_c('img', {
          staticStyle: {
            "height": "400px",
            "width": "500px"
          },
          attrs: {
            "src": scope.row.url
          }
        }), _vm._v(" "), _c('img', {
          staticStyle: {
            "max-height": "50px",
            "max-width": "130px"
          },
          attrs: {
            "slot": "reference",
            "src": scope.row.url,
            "alt": scope.row.url
          },
          slot: "reference"
        })])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "position": "absolute",
      "margin-left": "530px",
      "margin-top": "20px"
    },
    attrs: {
      "background": "",
      "layout": "total, prev, pager, next, jumper",
      "current-page": _vm.query.page,
      "page-size": _vm.pagesize,
      "total": _vm.pageData.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  }), _vm._v(" "), _c('el-dialog', {
    staticStyle: {
      "position": "absolute",
      "width": "1200px",
      "left": "180px"
    },
    attrs: {
      "visible": _vm.upVisible,
      "close-on-click-modal": false,
      "before-close": _vm.closeDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.upVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "resform5",
    attrs: {
      "model": _vm.resform5,
      "label-width": "100px",
      "id": "resform5"
    }
  }, [_c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNumberId),
      expression: "showNumberId"
    }],
    attrs: {
      "prop": "name",
      "label": "数量id:"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.resform5.numberId),
      callback: function($$v) {
        _vm.$set(_vm.resform5, "numberId", $$v)
      },
      expression: "resform5.numberId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "name",
      "label": "商品名称:"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "请输入商品名称",
      "clearable": ""
    },
    model: {
      value: (_vm.resform5.name),
      callback: function($$v) {
        _vm.$set(_vm.resform5, "name", $$v)
      },
      expression: "resform5.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "spec",
      "label": "商品规格:"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "请输入商品规格",
      "clearable": ""
    },
    model: {
      value: (_vm.resform5.spec),
      callback: function($$v) {
        _vm.$set(_vm.resform5, "spec", $$v)
      },
      expression: "resform5.spec"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "number",
      "label": "商品数量:"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "请输入商品数量",
      "clearable": ""
    },
    model: {
      value: (_vm.resform5.number),
      callback: function($$v) {
        _vm.$set(_vm.resform5, "number", $$v)
      },
      expression: "resform5.number"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "url",
      "label": "商品图片:"
    }
  }, [_c('el-upload', {
    ref: "upload",
    staticClass: "upload-demo",
    attrs: {
      "limit": 1,
      "action": "/api/oss/addPicture",
      "on-preview": _vm.handlePreview,
      "on-remove": _vm.handleRemove,
      "on-success": _vm.handleSuccess,
      "before-upload": _vm.handleBeforeUpload,
      "on-exceed": _vm.handleExceed,
      "file-list": _vm.fileList,
      "list-type": "picture"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v("点击上传")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("只能上传1张jpg/png文件，且上传的图片名不能重复，大小不超过5M")])], 1)], 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "100%",
      "margin-top": "40px"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.resLoading
    },
    on: {
      "click": function($event) {
        return _vm.reservationUpdate('resform5')
      }
    }
  }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticStyle: {
      "position": "absolute",
      "width": "1200px",
      "left": "180px"
    },
    attrs: {
      "id": "form6",
      "visible": _vm.addVisible,
      "close-on-click-modal": false,
      "before-close": _vm.closeDialog1
    },
    on: {
      "update:visible": function($event) {
        _vm.addVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "resform6",
    attrs: {
      "model": _vm.resform6,
      "label-width": "100px",
      "rules": _vm.formRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "name",
      "label": "商品名称:"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "请输入商品名称",
      "clearable": ""
    },
    model: {
      value: (_vm.resform6.name),
      callback: function($$v) {
        _vm.$set(_vm.resform6, "name", $$v)
      },
      expression: "resform6.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "spec",
      "label": "商品规格:"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "请输入商品规格",
      "clearable": ""
    },
    model: {
      value: (_vm.resform6.spec),
      callback: function($$v) {
        _vm.$set(_vm.resform6, "spec", $$v)
      },
      expression: "resform6.spec"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "number",
      "label": "商品数量:"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "请输入商品数量",
      "clearable": ""
    },
    model: {
      value: (_vm.resform6.number),
      callback: function($$v) {
        _vm.$set(_vm.resform6, "number", $$v)
      },
      expression: "resform6.number"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "url",
      "label": "商品图片:"
    }
  }, [_c('el-upload', {
    ref: "upload",
    staticClass: "upload-demo",
    attrs: {
      "limit": 1,
      "action": "/api/oss/addPicture",
      "on-preview": _vm.handlePreview,
      "on-remove": _vm.handleRemove,
      "on-success": _vm.handleSuccess,
      "before-upload": _vm.handleBeforeUpload,
      "on-exceed": _vm.handleExceed,
      "file-list": _vm.fileList,
      "list-type": "picture"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v("点击上传")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("只能上传1张jpg/png文件，且上传的图片名不能重复，大小不超过5M")])], 1)], 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "100%",
      "margin-top": "40px"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.resLoading
    },
    on: {
      "click": function($event) {
        return _vm.reservationAdd('resform6')
      }
    }
  }, [_vm._v("确定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ad24b8f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/cdwgkj/ServiceProduct.vue
// module id = 595
// module chunks = 1